import ExtrachargeReportIndex from "@/views/report/extracharge/ExtrachargeReportIndex.vue";

const extrachargeReport = [
  {
    path: "/extracharge-report",
    name: "extracharge-report",
    component: ExtrachargeReportIndex,
    meta: {
      layout: "default",
      role: ["superadmin","backoffice","supervisor"],
      public: false,
    },
  },
];

export default extrachargeReport;